// extracted by mini-css-extract-plugin
export default {"ControlButtons":"control-buttons_ControlButtons__m7aZ+"};